import React from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import {
  LayoutDashboard, User, LogOut, Briefcase, MessageSquare, FileText, Globe,
} from 'lucide-react';
import SetupProgressBanner from '../../components/SetupProgressBanner';

const NAV = [
  { to: '/app/freelancer/dashboard', icon: LayoutDashboard, label: 'Dashboard' },
  { to: '/app/freelancer/profile', icon: User, label: 'Profilim & Portfolyo' },
  { to: '/app/freelancer/messages', icon: MessageSquare, label: 'Mesajlar' },
  { to: '/app/freelancer/invoices', icon: FileText, label: 'Başvurularım' },
];

export default function FreelancerLayout() {
  const { logout, user, token } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => { logout(); navigate('/'); };

  return (
    <div className="min-h-screen bg-gray-50 flex">
      {/* Sidebar */}
      <aside className="w-56 bg-gray-950 flex flex-col shrink-0">
        {/* Logo */}
        <div className="px-5 py-5 border-b border-gray-800">
          <div className="flex items-center gap-2">
            <div className="w-7 h-7 bg-red-600 rounded-lg flex items-center justify-center shrink-0">
              <span className="text-white font-black text-xs">ES</span>
            </div>
            <div>
              <p className="text-white font-black text-sm leading-tight">EXPO STAND</p>
              <p className="text-red-400 text-[10px] font-medium">Freelancer</p>
            </div>
          </div>
        </div>

        {/* User */}
        <div className="px-4 py-3 border-b border-gray-800">
          <div className="w-8 h-8 rounded-full bg-red-600 flex items-center justify-center mb-1">
            <span className="text-white text-xs font-bold">{(user?.name || 'F')[0].toUpperCase()}</span>
          </div>
          <p className="text-white text-xs font-semibold truncate">{user?.name || 'Freelancer'}</p>
          <p className="text-gray-500 text-[10px] truncate">{user?.email || ''}</p>
        </div>

        {/* Nav */}
        <nav className="flex-1 px-2 py-3 space-y-0.5">
          {NAV.map(({ to, icon: Icon, label }) => (
            <NavLink key={to} to={to} end
              className={({ isActive }) =>
                `flex items-center gap-2.5 px-3 py-2 rounded-lg text-xs font-medium transition-all
                ${isActive ? 'bg-red-600 text-white' : 'text-gray-400 hover:bg-gray-800 hover:text-white'}`
              }>
              <Icon className="h-4 w-4 shrink-0" />{label}
            </NavLink>
          ))}
        </nav>

        {/* Bottom */}
        <div className="px-2 py-3 border-t border-gray-800 space-y-1.5">
          {/* Setup Progress Banner — dark mode uyumlu */}
          <SetupProgressBanner
            role="freelancer"
            accentColor="red"
            token={token}
            onboardingUrl="/app/freelancer/profile"
            doneKey="freelancer_onboarding_done"
            profileApi={null}
            totalSteps={4}
          />
          <button onClick={() => navigate('/job-board')}
            className="w-full flex items-center gap-2.5 px-3 py-2 rounded-lg text-xs font-medium text-gray-400 hover:bg-gray-800 hover:text-white transition-all">
            <Globe className="h-4 w-4" />İş İlanları
          </button>
          <button onClick={handleLogout}
            className="w-full flex items-center gap-2.5 px-3 py-2 rounded-lg text-xs font-medium text-gray-400 hover:bg-red-900 hover:text-red-300 transition-all">
            <LogOut className="h-4 w-4" />Çıkış Yap
          </button>
        </div>
      </aside>

      {/* Main */}
      <main className="flex-1 overflow-auto p-6">
        <Outlet />
      </main>
    </div>
  );
}
